import { toast } from 'sonner';
import { useNavigate } from 'react-router';
import { ArrowRight } from 'lucide-react';
import { useCallback } from 'react';
import { useMutation } from '@apollo/client/react';

import { getApiError } from 'src/utils/errors';
import { refetchAppProtections } from 'src/containers/Applications/Protections/api';
import { AgreementFormEnum } from 'src/graphql/schema';
import { SoftwareEscrowCreateDocument } from 'src/graphql/actions/softwareEscrow/softwareEscrowCreate.mutation';
import { Button } from '@/components/ui/button';

import { useSoftwareEscrowNewContext } from '../model';

const CreateAction = () => {
  const { appId, onSubmit, isValid } = useSoftwareEscrowNewContext();
  const navigate = useNavigate();
  const [createEscrow, { loading }] = useMutation(SoftwareEscrowCreateDocument);

  const onSave = useCallback(() => {
    onSubmit(async ({ agreementForm }) => {
      try {
        const { data } = await createEscrow({
          variables: {
            appId,
            agreementForm: agreementForm as AgreementFormEnum,
          },
        });
        if (data?.softwareEscrowCreate?.success) {
          refetchAppProtections();
          navigate(`/software-escrows/onboarding/${data?.softwareEscrowCreate?.softwareEscrow?.id}`);
        }
      } catch (e) {
        getApiError(e, toast.error);
      }
    });
  }, [appId, onSubmit, createEscrow, navigate]);

  return (
    <Button disabled={!isValid || loading} onClick={onSave} isLoading={loading}>
      Next <ArrowRight />
    </Button>
  );
};

export default CreateAction;
